export default __webpack_public_path__ + "fonts/glyphicons-halflings-regular.eot";